const DEFAULT_API_URL = "/api";

function resolveApiBaseUrl(): string {
  const fromEnv = import.meta.env.VITE_API_URL;
  if (fromEnv != null && String(fromEnv).trim() !== "") {
    return String(fromEnv).replace(/\/$/, "");
  }
  return DEFAULT_API_URL;
}

/** API base path (no trailing slash). Default `/api` on current origin; override with `VITE_API_URL` for local dev. */
export const apiUrl = resolveApiBaseUrl();

/** Cached raw `themeOptions` from `GET /tenant-branding/me` (session only). */
export const TENANT_BRANDING_THEME_STORAGE_KEY = "tenantBrandingThemeOptions";

/** Cached `tenantName` from the same response (session only). */
export const TENANT_BRANDING_NAME_STORAGE_KEY = "tenantBrandingTenantName";

/** Cached `appTitle` from branding (session only; used for `document.title` / print PDF names). */
export const TENANT_BRANDING_APP_TITLE_STORAGE_KEY = "tenantBrandingAppTitle";

/** Cached `trustName` from `GET /tenant-branding/me` (session only). */
export const TENANT_BRANDING_TRUST_NAME_STORAGE_KEY = "tenantBrandingTrustName";

/** Cached `trustId` from `GET /tenant-branding/me` (session only). */
export const TENANT_BRANDING_TRUST_ID_STORAGE_KEY = "tenantBrandingTrustId";

/** Cached `logoUrl` from `GET /tenant-branding/me` (session only). */
export const TENANT_BRANDING_LOGO_URL_STORAGE_KEY = "tenantBrandingLogoUrl";

/** Cached `razaPrintPaperSize` from authenticated `GET /tenant-branding/me` (session only). */
export const TENANT_BRANDING_RAZA_PRINT_PAPER_SIZE_STORAGE_KEY = "tenantBrandingRazaPrintPaperSize";

/** @param _resource Ignored; API base is single origin. Kept for call-site compatibility. */
export const getApiUrl = (_resource?: string): string => apiUrl;

export const EVENT_TYPE_CHOICES = [
  { id: "SHEHRULLA", name: "Shehrulla (Ramadan)" },
  { id: "ASHARA", name: "Ashara" },
];

export type EventTypeChoice = (typeof EVENT_TYPE_CHOICES)[number]["id"];

export const EMPLOYEE_TYPE: Record<string, string> = {
  FM_STAFF: "FM STAFF",
  BH_STAFF: "BH STAFF",
  FMB_STAFF: "FMB STAFF",
  ROTI_STAFF: "ROTI STAFF",
  ADMIN: "ADMIN",
};

export const PAYMENT_MODE_CONST: Record<string, string> = {
  cash: "Cash",
  cheque: "Cheque",
  online: "Online",
};

export const Page404 = "Page not found, go home!";

export const getType = (type: string): string => {
  if (type === "MUTTAVATTEEN") {
    return "CHULA";
  }
  return type;
};

export const isYearlySabilType = (type: string | null | undefined): boolean =>
  type === "ESTABLISHMENT" || type === "PROFESSIONAL" || type === "MUTTAVATTEEN_YEARLY";

export const isPersonalSabilType = (type: string | null | undefined): boolean =>
  type === "CHULA" || type === "MUTTAVATTEEN" || type === "MUTTAVATTEEN_YEARLY";

export const SABIL_TYPE_OPTIONS: { id: string; name: string }[] = [
  { id: "CHULA", name: "CHULA" },
  { id: "ESTABLISHMENT", name: "ESTABLISHMENT" },
  { id: "MUTTAVATTEEN", name: "MUTTAVATTEEN" },
  { id: "MUTTAVATTEEN_YEARLY", name: "MUTTAVATTEEN YEARLY" },
];

export const slotTimeRanges: Record<string, [number, number]> = {
  morning: [7, 10],
  afternoon: [12, 15],
  evening: [17, 23],
};

export const slotNameMap: Record<string, string> = {
  morning: "Morning",
  afternoon: "Afternoon",
  evening: "Evening",
};

export const dateFilterOptions: { id: string; name: string }[] = [
  { id: "TODAY", name: "Today" },
  { id: "YESTERDAY", name: "Yesterday" },
  { id: "WEEK_TO_DATE", name: "Week to Date" },
  { id: "MONTH_TO_DATE", name: "Month to Date" },
  { id: "YEAR_TO_DATE", name: "Year to Date" },
  { id: "CURRENT_FINANCIAL_YEAR", name: "Financial Year" },
  { id: "LAST_7_DAYS", name: "Last 7 Days" },
  { id: "LAST_30_DAYS", name: "Last 30 Days" },
  { id: "LAST_90_DAYS", name: "Last 90 Days" },
  { id: "LAST_180_DAYS", name: "Last 180 Days" },
  { id: "LAST_365_DAYS", name: "Last 365 Days" },
];
